export enum ProductSourceType {
    reservationFee = 1,
    bespokeProduct = 2,
    product = 3,
}
